export type CollectionMemberStatus = 'pending' | 'scheduled' | 'used';

export interface FirestoreAssetCollection {
  sessionId: string;
  name: string;
  emoji?: string;
  parentId: string | null;
  position: number;
  hidden: boolean;
  memberCount: number;
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
}

export interface FirestoreCollectionMember {
  sourceId: string;
  rowId: string;
  status: CollectionMemberStatus;
  scheduledDate?: Date;
  scheduleNotes?: string;
  addedAt: Date;
  addedBy: string;
}

/**
 * Composite member document ID. Parsing uses the first `_` as the separator —
 * `sourceId` and `rowId` must not contain underscores.
 */
export function getCollectionMemberDocId(sourceId: string, rowId: string): string {
  if (sourceId.includes('_') || rowId.includes('_')) {
    throw new Error('sourceId and rowId must not contain underscores');
  }
  return `${sourceId}_${rowId}`;
}

export function parseCollectionMemberDocId(memberDocId: string): {
  sourceId: string;
  rowId: string;
} {
  const separatorIndex = memberDocId.indexOf('_');
  if (separatorIndex <= 0) {
    throw new Error(`Invalid collection member doc id: ${memberDocId}`);
  }
  return {
    sourceId: memberDocId.slice(0, separatorIndex),
    rowId: memberDocId.slice(separatorIndex + 1),
  };
}
